import React, { useEffect } from "react";
import { dialogA11yProps } from "../utils/dialogA11yProps";

/**
 * Right-edge modal shell: backdrop, panel container, body scroll lock, Escape to close.
 * Put headers, forms, or read-only “show” layouts in `children`.
 */
export default function Drawer({
  open,
  onClose,
  children,
  ariaLabelledBy,
  ariaLabel,
  panelClassName = "",
  backdropLabel = "Close panel",
}) {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div
      className="drawer fixed inset-0 z-[60]"
      role="dialog"
      aria-modal="true"
      {...dialogA11yProps({ ariaLabelledBy, ariaLabel })}
    >
      <button
        type="button"
        className="drawer__backdrop absolute inset-0 z-0 bg-black/40"
        aria-label={backdropLabel}
        onClick={onClose}
      />
      <aside
        className={`drawer__panel absolute inset-y-0 right-0 z-10 flex h-full min-h-0 w-full max-w-md flex-col border-l border-[var(--color-border)] bg-[var(--color-surface)] shadow-lg transition-transform duration-200 ease-out ${panelClassName}`.trim()}
      >
        {children}
      </aside>
    </div>
  );
}
